import React, { useState, useEffect, useRef } from "react";
import "./TvVideoPage.css";

const videos = [
  { src: "/videos/video1.mp4", title: "Video 1" },
  { src: "/videos/video2.mp4", title: "Video 2" },
  { src: "/videos/video3.mp4", title: "Video 3" },
];

export default function TvVideoPage() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showControls, setShowControls] = useState(true);
  const videoRef = useRef(null);
  const hideTimeout = useRef(null);

  // Auto-hide controls
  const resetHideTimeout = () => {
    setShowControls(true);
    clearTimeout(hideTimeout.current);
    hideTimeout.current = setTimeout(() => setShowControls(false), 3000);
  };

  useEffect(() => {
    document.addEventListener("mousemove", resetHideTimeout);
    return () => document.removeEventListener("mousemove", resetHideTimeout);
  }, []);

  const handleEnded = () => {
    setCurrentIndex((prev) => (prev + 1) % videos.length);
  };

  const slideToNext = () => {
    setCurrentIndex((prev) => (prev + 1) % videos.length);
  };

  const slideToPrev = () => {
    setCurrentIndex((prev) => (prev - 1 + videos.length) % videos.length);
  };

  // Keyboard navigation
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (["ArrowRight", "ArrowDown"].includes(e.key)) slideToNext();
      if (["ArrowLeft", "ArrowUp"].includes(e.key)) slideToPrev();
      if (e.key === "Enter") toggleFullscreen();
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  const toggleFullscreen = () => {
    const elem = videoRef.current;
    if (!document.fullscreenElement) {
      if (elem.requestFullscreen) elem.requestFullscreen();
      else if (elem.webkitRequestFullscreen) elem.webkitRequestFullscreen();
    } else {
      if (document.exitFullscreen) document.exitFullscreen();
    }
  };

  return (
    <div className="tv-video-page" onMouseMove={resetHideTimeout}>
      <video
        ref={videoRef}
        key={videos[currentIndex].src}
        src={videos[currentIndex].src}
        autoPlay
        muted
        playsInline
        onEnded={handleEnded}
        className="tv-video-main"
      />

      {showControls && (
        <div className="tv-video-controls">
          <button onClick={slideToPrev}>⏮ Prev</button>
          <button onClick={toggleFullscreen}>⛶ Fullscreen</button>
          <button onClick={slideToNext}>Next ⏭</button>
          <div className="tv-video-title">{videos[currentIndex].title}</div>
        </div>
      )}
    </div>
  );
}
